import React from 'react';
import { FileText } from 'lucide-react';
import { Tournament } from '../../types';

interface RuleButtonProps {
  tournament: Tournament;
  className?: string;
  showNoRulesMessage?: boolean;
}

export function RuleButton({ tournament, className = "", showNoRulesMessage = false }: RuleButtonProps) {
  const hasRules = !!(tournament.rulesText || tournament.rulesPdfUrl);
  const rulesUrl = tournament.rulesPdfUrl || (tournament.rulesText?.startsWith('http') ? tournament.rulesText : null);

  if (!hasRules) {
    return null;
  }

  return (
    <a
      href={rulesUrl || "#"}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => {
        e.stopPropagation();
        if (!rulesUrl) {
          e.preventDefault();
          alert(`Reglamento: ${tournament.rulesText}`);
        }
      }}
      className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white/10 border border-white/20 text-white text-[9px] font-black uppercase tracking-widest hover:scale-105 active:scale-95 transition-all shadow-md ${className}`}
    >
      <FileText size={11} /> Ver Reglamento
    </a>
  );
}
